export const SET_COMPONENT_DATA = 'componentData/SET';

export const setComponentData = (payload) => (dispatch) => {
  dispatch({ type: SET_COMPONENT_DATA, payload });
  return Promise.resolve();
};
